import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import styled from 'styled-components';
import InnovationImg from '../assets/innovation.jpg';
import IntegrityImg from '../assets/integrity.jpg';
import InclusivityImg from '../assets/inclusivity.jpg';
import ImpactImg from '../assets/impact.jpg';
import CollaborationImg from '../assets/Collaboration.jpg';
import SustainabilityImg from '../assets/Sustainability.jpg';
import TestimonialsSection from './Testimonials';


const AboutUsContainer = styled.div`
    padding: 2rem;
    padding-bottom: 0;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Arial', sans-serif;
    color: #333;
`;

const TabsWrapper = styled(Tabs)`
    .MuiTabs-indicator {
        background-color: black;
    }
    margin-bottom: 1rem; /* Add margin below the tabs */
`;

// ...existing code...
const TabLabel = styled(Tab)`
  
`;
// ...existing code...

const TabContent = ({ value, index, children }) => {
    return value === index && <Box>{children}</Box>;
};

const CardSection = styled.section`
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    margin-bottom: 2rem;
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }
`;

const Title = styled.h2`
    font-size: 2rem;
    color: #1a1a1a;
    margin-bottom: 1rem;
    border-bottom: 2px solid black;
    display: inline-block;
`;

const Description = styled.p`
    font-size: 1.1rem;
    line-height: 1.6;
    color: #555;
`;

const Highlight = styled.span`
    color: rgb(26, 27, 28);
    font-weight: bold;
`;

const ServiceList = styled.ul`
    list-style-type: disc;
    margin-left: 2rem;
    margin-top: 1rem;
`;

const ServiceItem = styled.li`
    font-size: 1rem;
    color: #555;
    margin-bottom: 0.5rem;
`;

const ValueList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 2rem;
`;

const ValueItem = styled.div`
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    text-align: center;
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }
`;

const ValueImage = styled.img`
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 10px;
    margin-bottom: 1rem;
`;

const ValueTitle = styled.h3`
    font-size: 1.5rem;
    color: #1a1a1a;
    margin-bottom: 0.5rem;
`;

const ValueDescription = styled.p`
    font-size: 1rem;
    color: #555;
`;


const AboutUs = () => {
    const [value, setValue] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <AboutUsContainer>
<TabsWrapper value={value} onChange={handleTabChange} aria-label="about us tabs">
    <TabLabel
        value={0}
        label="About Us"
        sx={{
            fontSize: '1.05rem',
            fontWeight: 'bold',
            color: '#333',
            '&.Mui-selected': {
                color: '#333',
                borderBottom: '2px solid black',
            },
            '&:hover': {
                color: 'grey',
            },
        }}
    />
    <TabLabel
        value={1}
        label="Testimonials"
        sx={{
            fontSize: '1.05rem',
            fontWeight: 'bold',
            color: '#333',
            '&.Mui-selected': {
                color: '#333',
                borderBottom: '2px solid black',
            },
            '&:hover': {
                color: 'grey',
            },
        }}
    />
</TabsWrapper>


            {/* Tab Content */}
            <TabContent value={value} index={0}>
                <CardSection>
                    <Title>Who We Are</Title>
                    <Description>
                        At <Highlight>Rasynth</Highlight>, we’re more than just a tech company—we’re innovators, dreamers, and problem-solvers. Our mission is to redefine the boundaries of technology and creativity, crafting solutions that empower individuals and businesses to thrive in a rapidly evolving digital world.
                    </Description>
                </CardSection>

                <CardSection>
                    <Title>Our Story</Title>
                    <Description>
                        Rasynth was born out of a shared passion for technology and a desire to create tools that inspire and enable. Founded in 2024 by three passionate friends, our journey began with a vision to provide AI services and create products that help customers at a very minimal price. From late-night brainstorming sessions to early product launches, our story is one of dedication, innovation, and a relentless pursuit of excellence.
                    </Description>
                </CardSection>

                <CardSection>
                    <Title>What We Do</Title>
                    <Description>
                        We specialize in Software & AI Services, Digital Marketing Services, and Talent Acquisition Services. Our expertise lies in creating intuitive, scalable, and future-proof solutions that solve real-world problems. Whether you’re a startup looking to disrupt the market or an established enterprise seeking to optimize operations, we’ve got you covered.
                    </Description>
                    <ServiceList>
                        <ServiceItem>Custom Software Development</ServiceItem>
                        <ServiceItem>AI & Machine Learning</ServiceItem>
                        <ServiceItem>Blockchain Technology</ServiceItem>
                        <ServiceItem>Consulting & Strategy</ServiceItem>
                    </ServiceList>
                </CardSection>

                <CardSection>
                    <Title>Our Team</Title>
                    <Description>
                        Behind every great product is a team of passionate individuals. At Rasynth, we’re proud to have a diverse and talented team of engineers, designers, strategists, and visionaries who bring their unique perspectives to the table.
                    </Description>
                </CardSection>

                <CardSection>
                    <Title>Our Values</Title>
                    <ValueList>
                        <ValueItem>
                            <ValueImage src={InnovationImg} alt="Innovation" />
                            <ValueTitle>Innovation</ValueTitle>
                            <ValueDescription>
                                We’re constantly exploring new ideas and technologies to stay ahead of the curve.
                            </ValueDescription>
                        </ValueItem>
                        <ValueItem>
                            <ValueImage src={IntegrityImg} alt="Integrity" />
                            <ValueTitle>Integrity</ValueTitle>
                            <ValueDescription>
                                We believe in doing the right thing, even when no one is watching.
                            </ValueDescription>
                        </ValueItem>
                        <ValueItem>
                            <ValueImage src={InclusivityImg} alt="Inclusivity" />
                            <ValueTitle>Inclusivity</ValueTitle>
                            <ValueDescription>
                                We celebrate diversity and strive to create an environment where everyone feels valued.
                            </ValueDescription>
                        </ValueItem>
                        <ValueItem>
                            <ValueImage src={ImpactImg} alt="Impact" />
                            <ValueTitle>Impact</ValueTitle>
                            <ValueDescription>
                                We’re committed to making a positive difference in the world through our work.
                            </ValueDescription>
                        </ValueItem>
                        <ValueItem>
                            <ValueImage src={CollaborationImg} alt="Collaboration" />
                            <ValueTitle>Collaboration</ValueTitle>
                            <ValueDescription>
                                We believe in the power of teamwork and collaboration to achieve extraordinary results.
                            </ValueDescription>
                        </ValueItem>
                        <ValueItem>
                            <ValueImage src={SustainabilityImg} alt="Sustainability" />
                            <ValueTitle>Sustainability</ValueTitle>
                            <ValueDescription>
                                We are dedicated to building solutions that are environmentally responsible and sustainable.
                            </ValueDescription>
                        </ValueItem>
                    </ValueList>
                </CardSection>
            </TabContent>

            <TabContent value={value} index={1}>
               <TestimonialsSection />
            </TabContent>
            
            
        </AboutUsContainer>
    );
};

export default AboutUs;

// Styled Components

